import { of } from 'rxjs';

export const EMPTY_FIELD_STATE_ARGS = of({});
